/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { niveauActions } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_040: Question = {
  id: 'pres-040-declaration-eee',
  oldId: '54',
  title: 'Déclaration des EEE présentes sur le territoire',
  number: '4.2',
  description: ['Les occurrences connues d’EEE présentes sur le territoire ont été déclarées sur l’outil Sentinelle'],
  type: QuestionType.ACTIVITY,
  frequency: 1,
  idEM: 5,
  slots: [
    {
      type: SlotTypes.NIVEAU,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: false,
      optional: false,
      scoringFct: (data: string[]) => parseFloat(data[0]),
      score: '0',
      maxScore: 1,
      help: niveauActions,
      unit: SlotUnit.OPTIONS,
    },
  ],
};

export const question_pres_040_v2: Question = question_pres_040;
export const question_pres_040_v3: Question = question_pres_040;
